module.exports = __webpack_public_path__ + "img/module9.a469b2ce.png";